// removed by extract-text-webpack-plugin
module.exports = {"navigation":"Navigation__navigation___2B92O"};